import Cookies from "js-cookie"

const getToken = () => {
    return Cookies.get("token")
}

const setToken = (name, opts) => {
    Cookies.set(name, {domain: `.admin.stllr.io`, ...opts})
}

const signout = () => {
    Cookies.remove("token")
    window.location.href = process.env.REACT_APP_STLLR_ADMIN_URL
}

const ensureHttpsUrl = (url) => {
    if (!url || typeof url !== 'string') return url

    const trimmedUrl = url.trim()

    // If URL already starts with https://, return as is
    if (trimmedUrl.startsWith('https://')) {
        return trimmedUrl
    }

    // If URL starts with http://, replace with https://
    if (trimmedUrl.startsWith('http://')) {
        return trimmedUrl.replace('http://', 'https://')
    }

    // Otherwise, prepend https://
    return `https://${trimmedUrl}`
}

const isValidUrl = (url) => {
    if (!url || typeof url !== 'string') return false

    try {
        const urlObj = new URL(url)
        return urlObj.protocol === 'http:' || urlObj.protocol === 'https:'
    } catch {
        return false
    }
}

// Staff roles (user_roles): admin, accountant, operator, assistant admin, marketeer, support. Each
// staff member holds one; pages per person are limited in components/Header.js.
const STAFF_ROLE_IDS = [3, 4, 5, 8, 11, 12]

const isStaff = (user) => (user?.roles || []).some(role => STAFF_ROLE_IDS.includes(Number(role)))

export { getToken, setToken, signout, ensureHttpsUrl, isValidUrl, isStaff }